export default __webpack_public_path__ + "static/media/process.0577c463.png";